import type { FC } from 'react';
import { Button, Form } from 'react-bootstrap';
import { format } from 'date-fns';

interface DateNavigationProps {
  currentWeek: Date;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
  onWeekChange: (date: Date) => void;
}

const DateNavigation: FC<DateNavigationProps> = ({
  currentWeek,
  onPreviousWeek,
  onNextWeek,
  onWeekChange,
}) => {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = new Date(e.target.value);
    if (!isNaN(selectedDate.getTime())) {
      onWeekChange(selectedDate);
    }
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <Form.Control
        type="date"
        value={format(currentWeek, 'yyyy-MM-dd')}
        onChange={handleDateChange}
        className="daterange-input"
        style={{ width: 'auto' }}
      />
      <Button variant="secondary" onClick={onPreviousWeek} className="report-btn">
        <i className="bi bi-arrow-left"></i>
      </Button>
      <Button variant="secondary" onClick={onNextWeek} className="report-btn">
        <i className="bi bi-arrow-right"></i>
      </Button>
    </div>
  );
};

export default DateNavigation;
